import { cx } from '@emotion/css';
import { FC } from 'react';

export interface LabelProps {
  disabled?: boolean;
  text: string;
  className?: string;
}

export const Label: FC<React.PropsWithChildren<LabelProps>> = ({ disabled = false, text, className }) => {
  return <div className={cx('stihl-text-body-sm-reg', { 'text-secondary': disabled }, className)}>{text}</div>;
};
